import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { combineLatest } from 'rxjs';
import jsPDF from 'jspdf';
//import blobStream from 'blob-stream';


@Component({
  selector: 'call-recording-analysis-page',
  templateUrl: './call-recording-analysis-page.component.html',
  styleUrls: ['./call-recording-analysis-page.component.css']
})
export class CallRecordingAnalysisPageComponent implements OnInit {

  public loading: boolean = true;
  public error: boolean = false;

  public callRecordingPlatformId: number = 0;
  public callRecordingId: number = 0;
  public callRecordingSegmentId: number = 0;

  public summary: string = "";
  public transcription: string = "";
  public sentiment: any = null;


  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    debugger
    var callRecordingPlatformIdP = this.route.snapshot.queryParams["callRecordingPlatformId"];
    if (callRecordingPlatformIdP !== null) this.callRecordingPlatformId = parseInt(callRecordingPlatformIdP);

    var callRecordingIdP = this.route.snapshot.queryParams["callRecordingId"];
    if (callRecordingIdP !== null) this.callRecordingId = parseInt(callRecordingIdP);

    var callRecordingSegmentIdP = this.route.snapshot.queryParams["callRecordingSegmentId"];
    if (callRecordingSegmentIdP !== null) this.callRecordingSegmentId = parseInt(callRecordingSegmentIdP);
  }

  ngOnInit(): void {
    var transcriptionTask = this.http.get(`/CallRecording/Analysis/GetRecordingTranscription?callRecordingPlatformId=${this.callRecordingPlatformId}&callRecordingId=${this.callRecordingId}&callRecordingSegmentId=${this.callRecordingSegmentId}`, {responseType: 'text'} );
    var sentimentTask = this.http.get<any>(`/CallRecording/Analysis/GetRecordingSentiment?callRecordingPlatformId=${this.callRecordingPlatformId}&callRecordingId=${this.callRecordingId}&callRecordingSegmentId=${this.callRecordingSegmentId}`);
    var summaryTask = this.http.get<any>(`/CallRecording/Analysis/GetRecordingSummary?callRecordingPlatformId=${this.callRecordingPlatformId}&callRecordingId=${this.callRecordingId}&callRecordingSegmentId=${this.callRecordingSegmentId}`);

    combineLatest([transcriptionTask, sentimentTask, summaryTask])
      .subscribe(result => {

        this.summary = result[2].Text;
        this.transcription = result[0];
        this.sentiment = result[1];


        this.error = false;
        this.loading = false;
      },
        error => {
          this.error = true;
          this.loading = false;
      });
  }


  export() {
    const doc = new jsPDF();
   // const stream =doc.pipe(blobStream());


    var splitTitle = doc.splitTextToSize(this.transcription, 270);
    var pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(11);
    var y = 7;
    for (var i = 0; i < splitTitle.length; i++) {
      if (y > 280) {
        y = 10;
        doc.addPage();
      }
      doc.text(splitTitle[i], 15, y);
      y = y + 7;
    }


    doc.save('transcription.pdf');
/*
    stream.on('finish', function () {
      // get a blob you can do whatever you like with
      const blob = stream.toBlob('application/pdf');

      // or get a blob URL for display in the browser
      const url = stream.toBlobURL('application/pdf');

      var a = document.createElement("a");
      a.href = url;
      a.download = "log.pdf";
      document.body.appendChild(a);
      a.click();

    });*/

  }


}
